import { call, takeLatest, put } from "redux-saga/effects";
import * as Sentry from "@sentry/react";
import {
  INITIATE_APPOINTMENT_APPLICATIONS,
  SEARCH_MEMBERS_FOR_APPLY_APPOINTMENT,
  SET_MEMBERS_FOR_APPLY_APPOINTMENT,
  SET_MEMBERS_FOR_APPLY_APPOINTMENT_FAIL,
  INITIATE_APPOINTMENT_APPLICATIONS_TRACKING,
  // SET_MEMBERS_FOR_APPOINTMENT_TRACKING,
} from "../../actionTypes/dashboard";
import Member from "../../../services/api/member";
import Appointment from "../../../services/api/appointment";

// import Appointment from "../../../services/api/appointment";

// onSuccess handler for appointment data api
const onMembersDataSuccess = (payload) => ({
  type: SET_MEMBERS_FOR_APPLY_APPOINTMENT,
  payload,
});

// const onTrackingMembersDataSuccess = (payload) => ({
//   type: SET_MEMBERS_FOR_APPOINTMENT_TRACKING,
//   payload,
// });

// onFail handler for appointment data api
const onMembersDataFail = (payload) => ({
  type: SET_MEMBERS_FOR_APPLY_APPOINTMENT_FAIL,
  payload,
});

/**
 * This function handles the appointment data api and sets the data in reducer accordingly
 *
 * @param {object} action contains the data required for this generator function
 */
function* getMembers(action) {
  try {
    const { data } = yield call(Member.structureLeaders, action.payload);
    const isBlockChief = action.payload.positionId === 26;
    yield put(
      onMembersDataSuccess({
        data: data.content,
        paginationInfo: !isBlockChief
          ? {
              currentPage: Number(data.number),
              totalPages: Number(data.totalPages),
              totalElements: Number(data.totalElements),
              pageSize: Number(data.size),
            }
          : null,
        blockChiefPaginationInfo: isBlockChief
          ? {
              currentPage: Number(data.number),
              totalPages: Number(data.totalPages),
              totalElements: Number(data.totalElements),
              pageSize: Number(data.size),
            }
          : null,
      })
    );
  } catch (error) {
    yield put(onMembersDataFail(error));
    Sentry.captureException(error);
  }
}

/**
 * This function handles the appointment data api and sets the data in reducer accordingly
 *
 * @param {object} action contains the data required for this generator function
 */
function* getAppointmentApplicationList(action) {
  try {
    const isMarkInteraction = action.payload?.status === "INTERVIEWED";

    const apiToCall = isMarkInteraction
      ? Appointment.getMarkInteraction
      : Appointment.getAppointmentApplications;

    const { data } = yield call(apiToCall, action.payload);

    yield put(
      onMembersDataSuccess({
        data: data.content,
        paginationInfo: {
          currentPage: Number(data.number),
          totalPages: Number(data.totalPages),
          totalElements: Number(data.totalElements),
          pageSize: Number(data.size),
        },
      })
    );
  } catch (error) {
    Sentry.captureException(error);
    yield put(onMembersDataFail(error));
  }
}

/**
 * This function handles the appointment data api and sets the data in reducer accordingly
 *
 * @param {object} action contains the data required for this generator function
 */

function* appointmentTrackingList(action) {
  try {
    const { data } = yield call(
      Appointment.appointmentTracking,
      action.payload
    );
    console.log("action", action.payload);
    yield put(
      onMembersDataSuccess({
        data: data.content,
        paginationInfo: {
          currentPage: Number(data.number),
          totalPages: Number(data.totalPages),
          totalElements: Number(data.totalElements),
          pageSize: Number(data.size),
        },
      })
    );
  } catch (error) {
    Sentry.captureException(error);
    yield put(onMembersDataFail(error));
  }
}

/**
 * Watcher saga for appointment
 */
function* watchAppointmentSaga() {
  yield takeLatest(SEARCH_MEMBERS_FOR_APPLY_APPOINTMENT, getMembers);
  yield takeLatest(
    INITIATE_APPOINTMENT_APPLICATIONS,
    getAppointmentApplicationList
  );
  yield takeLatest(
    INITIATE_APPOINTMENT_APPLICATIONS_TRACKING,
    appointmentTrackingList
  );
}
export default watchAppointmentSaga;
